import { render, staticRenderFns } from "./DashboardOrderDetails.vue?vue&type=template&id=4c1a6bf2&"
import script from "./DashboardOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./DashboardOrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardOrderDetails.vue?vue&type=style&index=0&id=4c1a6bf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports